import React from "react";
import Header from "../wrappers/Header";
import Footer from "../wrappers/Footer";

const Layout = ({ children }) => {
  return (
    <div className="page-wrapper">
      <Header />
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
